import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';

function Login() {
  const [form, setForm] = useState({ email: 'admin@gmail.com', password: 'password123' });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    console.log('handleSubmit called with email:', form.email); // Debug log
    setLoading(true);
    try {
      await login(form.email, form.password, navigate);
      toast.success('Successfully signed in!', { toastId: 'login-success' });
    } catch (err) {
      console.error('Login error in Login component:', err.message, err.stack); // Debug log
      // Toast is handled in AuthProvider
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4 sm:p-6">
      <div className="flex w-full max-w-4xl bg-white rounded-xl shadow-xl overflow-hidden">
        {/* Left Side: Form */}
        <div className="w-full md:w-1/2 p-6 sm:p-8">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-primary mb-4">
            Welcome Back!
          </h2>
          <p className="text-gray-600 text-base sm:text-lg mb-6">
            Sign in to access your account and explore educational content.
          </p>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
              <input
                type="email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="Enter your email"
                className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-secondary transition duration-200"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  placeholder="Enter your password"
                  className="w-full p-3 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-secondary transition duration-200"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-secondary transition duration-200"
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            <div className="flex justify-between items-center">
              <a
                href="/forgot-password"
                className="text-sm text-secondary hover:text-opacity-90 transition duration-200"
              >
                Forgot Password?
              </a>
            </div>
            <div className="flex space-x-4">
              <button
                type="submit"
                className="flex-1 bg-secondary text-white p-3 rounded-md font-semibold hover:bg-opacity-90 disabled:bg-secondary/70 transition duration-300"
                disabled={loading}
              >
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
              <button
                type="button"
                onClick={handleSignup}
                className="flex-1 bg-transparent border-2 border-secondary text-secondary p-3 rounded-md font-semibold hover:bg-secondary hover:text-white transition duration-300"
              >
                Sign Up
              </button>
            </div>
          </form>
        </div>

        {/* Right Side: Decorative Gradient */}
        <div className="hidden md:block w-1/2 bg-gradient-to-br from-primary to-secondary rounded-r-xl">
          <div className="h-full flex items-center justify-center bg-black/10">
            <img
              src="/logos/logo.png"
              alt="Logo"
              className="object-contain opacity-90 max-h-48"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;